<template>
  <div
    :class="customClass"
    :style="style"
  >
    <base-label
      v-if="label"
      :class="$style.labelContent"
      :for="id"
    >
      {{ label }}
    </base-label>
    <base-select-dropdown
      v-bind="$attrs"
      :placeholder="placeholder"
      :items="items"
      show-checkbox
      :model-value="value"
      :focus="focus"
      @update:model-value="emit('change', $event)"
    />
  </div>
</template>

<script setup lang="ts">
import BaseLabel from '@/shared/legacy/ui/label/label.vue';
import BaseSelectDropdown from '@/shared/ui/base-list/base-select-dropdown.vue';

defineOptions({
  inheritAttrs: false
});

const { items = [] } = defineProps<{
  id?: string;
  items?: {
    id: string;
    name: string;
  }[];
  placeholder?: string;
  value: string;
  label?: string;
  focus?: boolean;
  customClass?: any[] | string | any;
  style?: any[] | string | any;
}>();

const emit = defineEmits<{
  change: [string];
}>();
</script>

<style lang="less" module>
.labelContent {
  display: inline-flex;
  margin-bottom: 3px;
}
</style>

<i18n lang="json">{}</i18n>
